import { InputGroup } from "@kensho/neo";
import { ReactNode } from "react";

import { validateTranscriptName } from "../../../utils/validate-transcript-name";
import { FormState } from "./types";

interface TranscriptNameProps {
  transcriptName: string;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  error?: string;
}

export function TranscriptName({
  transcriptName,
  setFormState,
  error,
}: TranscriptNameProps): ReactNode {
  return (
    <InputGroup
      label="Name"
      isInvalid={!!error}
      errorText={error}
      value={transcriptName}
      onChange={(e) => {
        setFormState((prev) => ({
          ...prev,
          transcriptName: e.target.value,
          errors: {
            ...prev.errors,
            transcriptName: validateTranscriptName(e.target.value),
          },
        }));
      }}
    />
  );
}
